const localeEn = {
  en: {
    TITLE_1: 'Hi,',
    TITLE_2: 'What do you need to do today?',
    DESCRIPTION:
      'Access the main tools for talent management in your organization:',

    PERFORMANCE_COMPETENCES_LABEL: 'Performance',
    PERFORMANCE_COMPETENCES_TITLE: 'Objectives and competencies',
    PERFORMANCE_COMPETENCES_DESCRIPTION:
      'Quantify the performance and commitment of teams.',
    PERFORMANCE_COMPETENCES_CTA: 'See results',

    PERFORMANCE_FEEDBACK_LABEL: 'Performance',
    PERFORMANCE_FEEDBACK_TITLE: 'Feedback',
    PERFORMANCE_FEEDBACK_DESCRIPTION:
      "Improve your team's performance with constant feedback.",
    PERFORMANCE_FEEDBACK_CTA: 'See results',

    PERFORMANCE_PID_LABEL: 'Performance',
    PERFORMANCE_PID_TITLE: 'Individual Development Plan',
    PERFORMANCE_PID_DESCRIPTION:
      'Create processes to close gaps and promote Human Talent.',
    PERFORMANCE_PID_CTA: 'Create PID',

    CLIMATE_SURVEY_LABEL: 'Climate',
    CLIMATE_SURVEY_TITLE: 'Surveys',
    CLIMATE_SURVEY_DESCRIPTION:
      'Listen to the needs of people and create a better culture.',
    CLIMATE_SURVEY_CTA: 'Monitor climate',

    CLIMATE_RECOGNITION_LABEL: 'Climate',
    CLIMATE_RECOGNITION_TITLE: 'Recognition',
    CLIMATE_RECOGNITION_DESCRIPTION:
      'Manage the recognition culture through medals.',
    CLIMATE_RECOGNITION_CTA: 'See detail',

    LEARNING_SKILL_EVOLUTION_LABEL: 'E-Learning',
    LEARNING_SKILL_EVOLUTION_TITLE: 'Skill XP Evolution',
    LEARNING_SKILL_EVOLUTION_DESCRIPTION:
      'Measure the skills of your teams and identify areas of opportunity and growth.',
    LEARNING_SKILL_EVOLUTION_CTA: 'See results',

    LEARNING_GROUP_STATISTICS_LABEL: 'E-Learning',
    LEARNING_GROUP_STATISTICS_TITLE: 'Learning Paths',
    LEARNING_GROUP_STATISTICS_DESCRIPTION:
      'Analyze the learning progress of employees.',
    LEARNING_GROUP_STATISTICS_CTA: 'See progress',

    LEARNING_COURSES_LABEL: 'E-Learning',
    LEARNING_COURSES_TITLE: 'Customized Courses',
    LEARNING_COURSES_DESCRIPTION:
      "Manage your organization's learning content and plan customized training.",
    LEARNING_COURSES_CTA: 'See detail',

    CARD_LABEL_1: 'Performance',
    CARD_TITLE_1: 'Objectives and competencies',
    CARD_DESCRIPTION_1: 'Quantify the performance and commitment of teams.',
    CARD_CTA_1: 'See results',

    CARD_LABEL_2: 'Climate',
    CARD_TITLE_2: 'Surveys',
    CARD_DESCRIPTION_2:
      'Listen to the needs of people and create a better culture.',
    CARD_CTA_2: 'Monitor climate',

    CARD_LABEL_3: 'E-Learning',
    CARD_TITLE_3: 'Skill XP Evolution',
    CARD_DESCRIPTION_3:
      'Measure the skills of your teams and identify areas of opportunity and growth.',
    CARD_CTA_3: 'See results',

    CARD_LABEL_4: 'E-Learning',
    CARD_TITLE_4: 'Learning Paths',
    CARD_DESCRIPTION_4: 'Analyze the learning progress of employees.',
    CARD_CTA_4: 'See progress',

    CARD_LABEL_5: 'Performance',
    CARD_TITLE_5: 'Feedback',
    CARD_DESCRIPTION_5:
      "Improve your team's performance with constant feedback.",
    CARD_CTA_5: 'See results',

    CARD_LABEL_6: 'Climate',
    CARD_TITLE_6: 'Recognition',
    CARD_DESCRIPTION_6: 'Manage the recognition culture through medals.',
    CARD_CTA_6: 'See detail',

    CARD_LABEL_7: 'Performance',
    CARD_TITLE_7: 'Individual Development Plan',
    CARD_DESCRIPTION_7:
      'Create processes to close gaps and promote Human Talent.',
    CARD_CTA_7: 'Create PID',

    CARD_LABEL_8: 'E-Learning',
    CARD_TITLE_8: 'Customized Courses',
    CARD_DESCRIPTION_8:
      "Manage your organization's learning content and plan customized training.",
    CARD_CTA_8: 'See detail',

    // Home V2
    HEADER_V2_DESCRIPTION:
      'In this space, you will find the main tools for your growth within the company.',

    TITLE_1_MOBILE: 'Hi',

    CARDS_ENROLLED_COURSES_TITLE: 'Enrolled Courses',
    CARDS_ENROLLED_COURSES_DESCRIPTION:
      'Enter the courses you have assigned and continue your development.',
    CARDS_ENROLLED_COURSES_CTA: 'See my courses',
    CARDS_LEARNING_PATHS_TITLE: 'Learning Paths',
    CARDS_LEARNING_PATHS_DESCRIPTION:
      'Boost your skills with specialized and planned content for you.',
    CARDS_LEARNING_PATHS_CTA: 'See my paths',

    PROFILE_CARD_VIEW_PROFILE: 'View profile',
    PROFILE_CARD_OCCUPATION: 'Position',
    PROFILE_CARD_DEPARTMENT: 'Department',
    PROFILE_CARD_BOSS: 'Boss',
    PROFILE_CARD_LOCATION: 'Location',

    TALENT_CARD_TITLE: 'Human Talent Processes',
    TALENT_CARD_TITLE_SHORT: 'Talent Processes',
    TALENT_CARD_DESCRIPTION:
      'Access guides and tutorials to make the most of your courses and learning features.',

    GREETINGS: 'Welcome, {{name}}',
    DATE_PREPOSITION_DE: '',
    DATE_PREPOSITION_DEL: '',
  },
};

export default localeEn;
